import React from 'react';
import PropTypes from 'prop-types';

const FormatAmount = ({ 
  amount, 
  currency = 'GBP', 
  locale = 'en-GB', 
  showCurrency = true,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
  type = 'currency' // 'currency', 'number', 'decimal'
}) => {
  const formatValue = () => {
    if (amount === null || amount === undefined || isNaN(amount)) {
      return '0';
    }

    const numAmount = parseFloat(amount);

    try {
      switch (type) {
        case 'currency':
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: minimumFractionDigits,
            maximumFractionDigits: maximumFractionDigits
          }).format(numAmount);

        case 'number':
          return new Intl.NumberFormat(locale, {
            minimumFractionDigits: minimumFractionDigits,
            maximumFractionDigits: maximumFractionDigits
          }).format(numAmount);

        case 'decimal':
          return new Intl.NumberFormat(locale, {
            minimumFractionDigits: minimumFractionDigits,
            maximumFractionDigits: maximumFractionDigits
          }).format(numAmount);

        default:
          return numAmount.toString();
      }
    } catch (error) {
      // Fallback to basic formatting if Intl is not supported
      console.warn('Intl formatting failed, using fallback:', error);
      return showCurrency ? `${currency}${numAmount.toFixed(maximumFractionDigits)}` : numAmount.toFixed(maximumFractionDigits);
    }
  };

  return <span>{formatValue()}</span>;
};

FormatAmount.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  currency: PropTypes.string,
  locale: PropTypes.string,
  showCurrency: PropTypes.bool,
  minimumFractionDigits: PropTypes.number,
  maximumFractionDigits: PropTypes.number,
  type: PropTypes.oneOf(['currency', 'number', 'decimal'])
};

export default FormatAmount; 
